import styles from './index.module.scss';

export interface ConceptCardProps {
  image: string;
  title: string;
  description: string;
}

export default function ConceptCard({ image, title, description }: ConceptCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.imageWrap}>
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className={styles.text}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{description}</p>
      </div>
    </div>
  );
}
